import * as React from 'react';

import { connect } from 'react-redux';

import ListProductionGroupsView from 'list-production-groups.view';
import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformanceGroup, IPackage } from '../../custom/classes/production';
import { AnyAction } from 'redux';
import { setSpecialFeatureMap } from '../../redux-state/actions/package-listing.actions';
import { ISpecialFeatureMapValue } from '../../classes/package-listing';
import { createSpecialFeatureMap } from '../../helpers/special-feature-helpers';

interface IListProductionGroupsExternalProps {
}

interface DispatchToProps {
    setSpecialFeatureMap: (map: Map<string, ISpecialFeatureMapValue>) => void;
}

interface StateToProps {
    performanceGroups: IPerformanceGroup[];
    packageDetail: IPackage;
    text: IPackageListingAppText;
}

export type ListProductionGroupsProps = IListProductionGroupsExternalProps & StateToProps & DispatchToProps;


export class ListProductionGroupsBase extends React.Component<ListProductionGroupsProps, any> {

    componentDidMount() {
        const allPerformancesNested = this.props.performanceGroups.map(pg => pg.appProductions.map(prod => prod.performances));
        const allMergedPerformances = allPerformancesNested.flat(2);
        const sortedMap = createSpecialFeatureMap(allMergedPerformances, this.props.text.specialFeatureMessages);

        this.props.setSpecialFeatureMap(sortedMap);
    }

    render() {
        return (
            <ListProductionGroupsView {...this.props}  />
        )
    }
}

function mapDispatchToProps(dispatch: React.Dispatch<AnyAction>): DispatchToProps {
    return {
        setSpecialFeatureMap: (map) => dispatch(setSpecialFeatureMap(map)),
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListProductionGroupsExternalProps): StateToProps {
    return {
        performanceGroups: state.packageListing.packageDetail.performanceGroupDetails,
        packageDetail: state.packageListing.packageDetail,   
        text: state.packageListingText

    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListProductionGroupsBase);